import { render } from "./DentalBridgesBenefits.vue?vue&type=template&id=79b2a276"
import script from "./DentalBridgesBenefits.vue?vue&type=script&lang=js"
export * from "./DentalBridgesBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__